import React from "react";
import PostPreview from "components/PostPreview";
import CircularProgress from "@material-ui/core/CircularProgress";
import { BlogPost, RoutingProps } from "types/app";
import { getDrafts, removeDraft } from "services/blogActions";
import appContext from "services/appContext";
import useStyles from "styles/pages/Drafts.styles";
import useAsyncEffect from "use-async-effect";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import clsx from 'clsx';
import DeleteModal from "components/DeleteModal";

const Drafts: React.FunctionComponent<RoutingProps> = ({ handleRoute }) => {
  const classes = useStyles();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [drafts, setDrafts] = React.useState<BlogPost[]>([]);
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [deleteId, setDeleteId] = React.useState<string>('');
  const { state, dispatch } = React.useContext(appContext);
  const { loggedIn, isAdmin } = state.user;

  React.useEffect(() => {
    if (!loggedIn) {
      handleRoute("");
    }
  }, [loggedIn, handleRoute]);

  useAsyncEffect(async () => {
    if (loggedIn) {
      const newDrafts = await getDrafts({ state, dispatch })();
      setDrafts(newDrafts);
      setLoading(false);
    }
  }, []);

  const handleRemoveDraft = async () => {
    await removeDraft({ state, dispatch })(deleteId);
    const newDrafts = await getDrafts({ state, dispatch })();
    setDrafts(newDrafts);
    setModalOpen(false);
    setDeleteId('');
  };

  const handleAddPost = () => {
    handleRoute("write");
  };

  const handleDeleteModal = (draftId: string) => {
    setDeleteId(draftId);
    setModalOpen(true);
  };

  const toggleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <div className={classes.root}>
      {loading ? (
        <div className={classes.center}>
          <CircularProgress color="secondary" />
        </div>
      ) : (
        drafts.length > 0 ? (
          <>
            <Typography variant="h1" className={classes.title}>
              Drafts
            </Typography>
            {drafts.map((draft: BlogPost, index: number) => (
              <PostPreview
                key={index}
                post={draft}
                draft={true}
                handleRemove={handleDeleteModal}
                handleRoute={handleRoute}
              />
            ))}
          </>
        ) : (
          <div className={clsx(classes.center, classes.centerDirection)}>
            <Typography variant="h1" className={classes.title}>
              Drafts
            </Typography>
            <Typography variant="body1" display="block" className={classes.centerMessage}>
              There is no draft posts yet. Write your first one.
            </Typography>
            {(loggedIn && isAdmin) && (
              <Button
                variant="outlined"
                onClick={handleAddPost}
              >
                Write post
              </Button>
            )}
          </div>
        )
      )}
      {modalOpen && (
        <DeleteModal
          open={modalOpen}
          onClose={toggleModalClose}
          handleRemove={handleRemoveDraft}
        />
      )}
    </div>
  );
};

export default Drafts;
